import React from "react";
import { connect } from "react-redux";
import { getCurrencyOfCountry } from "../../../utils/utils";
import { Trans, useTranslation } from "react-i18next";

const CashbackDiagram = ({ cashbackSlabs, userOrderAmount, country }) => {
  const { t } = useTranslation();
  const currency = getCurrencyOfCountry(country);

  const getIsInTier = (tier) => {
    const min = parseFloat(tier.min_amount);
    const max = tier.max_amount ? parseFloat(tier.max_amount) : Infinity;
    return userOrderAmount >= min && userOrderAmount <= max;
  };

  const currentTierIndex = cashbackSlabs.findIndex(getIsInTier);

  if (currentTierIndex === -1) {
    return null;
  }
  const heavyFontStyle = {
    fontFamily: "Futura Heavy, sans-serif",
  };

  const nextTier = cashbackSlabs[currentTierIndex + 1];
  const amountAway = nextTier
    ? parseFloat(nextTier.min_amount) - userOrderAmount
    : null;

  const messageStyle = {
    padding: "15px",
    border: "1px solid #dee2e6",
    textAlign: "center",
    color: "#003366",
    fontSize: "15px",
    letterSpacing: "0.5px",
  };

  return (
    <div style={messageStyle}>
      {nextTier && amountAway > 0 ? (
        <>
          <Trans
            i18nKey="cashback.away_message"
            values={{
              currency,
              amount: amountAway.toFixed(2),
              cashback: `${currency} ${parseFloat(nextTier.cashback_amount)}`,
            }}
            components={{
              bold1: <span style={heavyFontStyle} />,
            }}
          />
          <br />
          <span style={{ color: "#003366" }}>{t("cashback.cta")}</span>
        </>
      ) : currentTierIndex === cashbackSlabs.length - 1 ? (
        <Trans
          i18nKey="cashback.max_level_unlocked"
          values={{
            cashback: `${currency} ${parseFloat(
              cashbackSlabs[currentTierIndex].cashback_amount
            )}`,
          }}
          components={{
            bold: <span style={heavyFontStyle} />,
          }}
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  country: state.language.country,
});

export default connect(mapStateToProps)(CashbackDiagram);
